(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-comfort-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ns-editorial-motion')) {
  customElements.define('ns-editorial-motion', class extends HTMLElement {
    connectedCallback() {
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionPreference = () => { this.stopMotion(); this.startMotion(); };
      this.motionPreference.addEventListener('change', this.onMotionPreference);
      this.onMotionFocus = event => {
        const target = event.target.closest('[data-nse-reveal="pending"]');
        if (target) this.revealContent(target);
      };
      this.addEventListener('focusin', this.onMotionFocus);
      this.motionFrame = requestAnimationFrame(() => this.startMotion());
    }
    startMotion() {
      if (!this.isConnected || !this.closest('.ns-editorial-page') || window.Shopify?.designMode || this.motionPreference.matches || !('IntersectionObserver' in window)) return;
      const targets = this.querySelectorAll(':scope > section:not(.nse-reviews):not(.nse-product-cta):not(.nse-promise), :scope > figure, :scope > .nse-benefit, .nse-reviews-feature-inner, .nse-reviews-inner, .nse-product-cta-heading, .nse-product-cta-card, .nse-promise > div, .nse-footer > div');
      this.motionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) this.revealContent(entry.target); });
      }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
      targets.forEach(target => {
        if (target.querySelector('.nse-floating-cta') || target.getBoundingClientRect().top < window.innerHeight) return;
        target.dataset.nseReveal = 'pending';
        this.motionObserver.observe(target);
      });
    }
    revealContent(target) {
      target.dataset.nseReveal = 'visible';
      this.motionObserver?.unobserve(target);
    }
    stopMotion() {
      this.motionObserver?.disconnect();
      this.motionObserver = null;
      this.querySelectorAll('[data-nse-reveal]').forEach(target => target.removeAttribute('data-nse-reveal'));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.motionFrame);
      this.stopMotion();
      this.motionPreference?.removeEventListener('change', this.onMotionPreference);
      this.removeEventListener('focusin', this.onMotionFocus);
    }
  });
}
if (!customElements.get('ns-editorial-product-picker')) {
  customElements.define('ns-editorial-product-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.pickerReady) { this.watchProductButton(); return; }
      const dataNode = this.querySelector('.nse-product-cta-data');
      if (!dataNode) return;
      let products;
      try { products = JSON.parse(dataNode.textContent); } catch { return; }
      const swatches = this.querySelector('.nse-product-cta-swatches');
      const options = this.querySelector('.nse-product-cta-options');
      const image = this.querySelector('.nse-product-cta-image');
      const title = this.querySelector('.nse-product-cta-title');
      const colourName = this.querySelector('.nse-product-cta-colour-name');
      const link = this.querySelector('.nse-product-cta-button');
      const colourMap = {white:'#f7f7f2',black:'#171a18',grey:'#989c9a',gray:'#989c9a',navy:'#1e2b43',navyblue:'#1e2b43',blue:'#5988b3',lightblue:'#add8e6',skyblue:'#add8e6',darkblue:'#1e2b43',beige:'#d8c9ad',cream:'#f5efdc',pink:'#e1a8b8',brown:'#81634a',green:'#789986',mixed:'conic-gradient(#f7f7f2 0 25%,#171a18 25% 50%,#989c9a 50% 75%,#5988b3 75%)',multicolor:'conic-gradient(#f7f7f2 0 25%,#171a18 25% 50%,#989c9a 50% 75%,#5988b3 75%)'};
      let selectedColour = '';
      const renderStyle = key => {
        const product = products[key];
        if (!product || !product.variants.length) return;
        title.textContent = product.title;
        const groups = [...new Set(product.variants.map(variant => variant.colour))].map(colour => product.variants.find(variant => variant.colour === colour && variant.available) || product.variants.find(variant => variant.colour === colour));
        const selected = groups.find(variant => variant.colour === selectedColour && variant.available) || groups.find(variant => variant.colour.toLowerCase() === 'white' && variant.available) || groups.find(variant => variant.available) || groups[0];
        const selectColour = variant => {
          selectedColour = variant.colour;
          colourName.textContent = variant.colour;
          swatches.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colour === variant.colour)));
          if (image && variant.image) { image.removeAttribute('srcset'); image.src = variant.image; image.alt = variant.alt || product.title; }
          link.href = product.url + '?variant=' + encodeURIComponent(variant.id);
        };
        swatches.replaceChildren();
        groups.forEach(variant => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'nse-product-swatch';
          button.dataset.colour = variant.colour;
          button.setAttribute('aria-label', 'Colour: ' + variant.colour);
          button.title = variant.colour;
          button.disabled = !variant.available;
          button.style.setProperty('--nse-swatch', colourMap[variant.colour.toLowerCase().replace(/[\s_-]/g, '')] || '#e7ede9');
          button.addEventListener('click', () => selectColour(variant));
          swatches.append(button);
        });
        selectColour(selected);
      };
      const initialKey = products.ankle?.variants.length ? 'ankle' : null;
      if (!initialKey) return;
      renderStyle(initialKey);
      options.hidden = false;
      this.pickerReady = true;
      this.watchProductButton();
    }
    watchProductButton() {
      this.ctaVisibilityObserver?.disconnect();
      this.ctaPage = this.closest('.ns-editorial-page');
      const button = this.querySelector('.nse-product-cta-button');
      if (!button || !this.ctaPage || !('IntersectionObserver' in window)) return;
      this.ctaVisibilityObserver = new IntersectionObserver(entries => {
        this.ctaPage.classList.toggle('nse-inline-cta-visible', entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.6));
      }, { threshold: [0, 0.6, 1] });
      this.ctaVisibilityObserver.observe(button);
    }
    disconnectedCallback() {
      this.ctaVisibilityObserver?.disconnect();
      this.ctaPage?.classList.remove('nse-inline-cta-visible');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-customer-reviews')) {
    customElements.define('ns-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const cards = [...this.querySelectorAll('.ns-reviews__card')];
        const button = this.querySelector('.ns-reviews__more');
        const status = this.querySelector('[data-review-status]');
        let shown = Math.min(Number(this.dataset.initial) || 6, cards.length);
        const update = (announce = false) => {
          cards.forEach((card, index) => { card.hidden = index >= shown; });
          button.hidden = shown >= cards.length;
          if (announce) status.textContent = status.dataset.template.replace('[shown]', shown).replace('[total]', cards.length);
        };
        button.addEventListener('click', () => {
          shown = Math.min(shown + (Number(this.dataset.batch) || 6), cards.length);
          update(true);
        }, { signal: this.controller.signal });
        const form = this.querySelector('.ns-reviews__write form');
        if (form?.querySelector('[role="status"], .errors')) this.querySelector('.ns-reviews__write').open = true;
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-home-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-home-photo-reviews')) {
    customElements.define('ns-home-photo-reviews', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const track = this.querySelector('.ns-photo-reviews__track');
        const buttons = [...this.querySelectorAll('[data-direction]')];
        const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
        const step = () => track.querySelector('article').getBoundingClientRect().width + 16;
        const update = () => buttons.forEach(button => {
          button.hidden = track.scrollWidth <= track.clientWidth + 2;
          button.disabled = Number(button.dataset.direction) < 0 ? track.scrollLeft < 2 : track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        });
        const move = direction => track.scrollBy({ left: direction * step(), behavior: reduced() ? 'auto' : 'smooth' });
        buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), options));
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        let drag;
        track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft };
          track.setPointerCapture(event.pointerId);
        }, options);
        track.addEventListener('pointermove', event => {
          if (!drag || drag.id !== event.pointerId) return;
          if (Math.abs(event.clientX - drag.x) > 6) track.classList.add('is-dragging');
          if (track.classList.contains('is-dragging')) track.scrollLeft = drag.left - (event.clientX - drag.x);
        }, options);
        const finish = () => { drag = null;track.classList.remove('is-dragging');update(); };
        ['pointerup','pointercancel','lostpointercapture'].forEach(type => track.addEventListener(type, finish, options));
        this.observer?.disconnect();
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.abort?.abort();this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-loop-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-loop-gallery')) {
    customElements.define('ns-loop-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const viewport = this.querySelector('.ns-loop-gallery__viewport');
        const track = this.querySelector('.ns-loop-gallery__track');
        const group = this.querySelector('.ns-loop-gallery__group');
        if (!viewport || !track || !group) return;
        const options = { signal: this.controller.signal };
        const videos = [...this.querySelectorAll('video')];
        const preference = matchMedia('(prefers-reduced-motion: reduce)');
        const sync = () => {
          const paused = this.classList.contains('is-paused') || this.classList.contains('is-offscreen') || this.classList.contains('is-held') || document.hidden || preference.matches;
          videos.forEach(video => {
            if (paused || (video.hasAttribute('data-ns-lazy-video') && video.dataset.nsVideoLoaded !== 'true')) video.pause();
            else video.play().catch(() => {});
          });
        };
        this.addEventListener('ns:video-ready', sync, options);
        const getAnimation = () => track.getAnimations().find(animation => animation.animationName === 'ns-gallery-loop');
        const seek = (animation, time) => {
          const duration = animation?.effect.getComputedTiming().duration;
          if (typeof duration !== 'number' || duration <= 0) return;
          // Wrap the animation phase so either drag direction remains seamless.
          animation.currentTime = ((time % duration) + duration) % duration;
        };
        let drag = null;
        const finishDrag = () => {
          const pointerId = drag?.pointerId;
          drag = null;
          this.classList.remove('is-held', 'is-dragging');
          if (pointerId != null && viewport.hasPointerCapture(pointerId)) viewport.releasePointerCapture(pointerId);
          sync();
        };
        viewport.addEventListener('dragstart', event => event.preventDefault(), options);
        viewport.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || drag || (preference.matches && event.pointerType === 'touch')) return;
          this.classList.add('is-held');
          const animation = getAnimation();
          drag = {
            pointerId: event.pointerId, x: event.clientX, y: event.clientY,
            animation, time: animation?.currentTime || 0,
            duration: animation?.effect.getComputedTiming().duration,
            width: group.getBoundingClientRect().width, scrollLeft: viewport.scrollLeft, active: false
          };
          viewport.setPointerCapture(event.pointerId);
          sync();
        }, options);
        viewport.addEventListener('pointermove', event => {
          if (!drag || event.pointerId !== drag.pointerId) return;
          const distance = event.clientX - drag.x;
          if (!drag.active) {
            const vertical = Math.abs(event.clientY - drag.y);
            if (Math.max(Math.abs(distance), vertical) < 6) return;
            if (vertical > Math.abs(distance)) { finishDrag(); return; }
            drag.active = true;
            this.classList.add('is-dragging');
          }
          event.preventDefault();
          if (drag.animation && typeof drag.duration === 'number' && drag.width > 0) {
            seek(drag.animation, drag.time - distance / drag.width * drag.duration);
          } else {
            viewport.scrollLeft = drag.scrollLeft - distance;
          }
        }, { ...options, passive: false });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => {
          viewport.addEventListener(type, event => {
            if (drag && event.pointerId === drag.pointerId) finishDrag();
          }, options);
        });
        viewport.addEventListener('keydown', event => {
          if (event.target !== viewport || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.code === 'Space') {
            event.preventDefault();
            this.classList.toggle('is-paused');
            sync();
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            const step = group.children[0]?.getBoundingClientRect().width + parseFloat(getComputedStyle(group).columnGap);
            const animation = getAnimation();
            const duration = animation?.effect.getComputedTiming().duration;
            if (animation && typeof duration === 'number' && group.offsetWidth > 0 && step > 0) {
              seek(animation, (animation.currentTime || 0) + direction * step / group.offsetWidth * duration);
            } else {
              viewport.scrollLeft += direction * (step || viewport.clientWidth / 2);
            }
          }
        }, options);
        window.addEventListener('resize', finishDrag, options);
        preference.addEventListener('change', finishDrag, options);
        document.addEventListener('visibilitychange', () => {
          this.classList.toggle('is-hidden', document.hidden);
          finishDrag();
        }, options);
        this.classList.toggle('is-hidden', document.hidden);
        this.observer = new IntersectionObserver(entries => {
          this.classList.toggle('is-offscreen', !entries[0].isIntersecting);
          sync();
        });
        this.observer.observe(this);
        this.finishDrag = finishDrag;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.finishDrag?.();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-similar-items"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-similar-items')) {
    customElements.define('ns-similar-items', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const rail = this.querySelector('.ns-similar__rail');
        const previous = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        if (!rail || !previous || !next) return;
        const update = () => {
          previous.disabled = rail.scrollLeft < 2;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        };
        [previous, next].forEach(button => button.addEventListener('click', () => {
          const card = rail.querySelector('.ns-similar__card');
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
          rail.scrollBy({ left: Number(button.dataset.direction) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.controller.signal }));
        rail.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(rail);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
